module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "holder"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_vm._v("Group by: ")]), _vm._v(" "), _vm._l((_vm.alinks), function(link) {
    return _c('li', [_c('a', {
      class: {
        active: link.active
      },
      attrs: {
        "href": link.item.path
      }
    }, [_vm._v(" " + _vm._s(link.item.name) + " ")])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37ada400!./~/vue-loader/lib/selector.js?type=template&index=0!./src/d3-components/bubbles-nested-routes/menu.vue
// module id = 122
// module chunks = 1